/** @format */

import {styled} from '@mui/material/styles';
import {Box, Button} from '@mui/material';

export const Root = styled(Button)(() => ({
  borderRadius: '8px',
  height: '32px',
  width: '126px',
  padding: 0,

  color: '#F9FCFE',
  fontSize: '14px',
  fontWeight: 400,
  lineHeight: '16px',
}));

export const Container = styled(Box, {
  shouldForwardProp: prop => prop !== 'bgColor',
})<{bgColor: string}>(({bgColor}) => ({
  borderRadius: '8px',
  background: bgColor,
  opacity: 0.2,
  height: '32px',
  width: '100%',
  position: 'relative',
  zIndex: 0,
}));

export const Content = styled(Box)(() => ({
  position: 'absolute',
  zIndex: 1,
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));
